import { cn } from '@/lib/utils'

// A one-word name gives its first letter, or the first `oneWordLetters` of it.
export function initials(name: string, { oneWordLetters = 1 }: { oneWordLetters?: number } = {}): string {
  const words = name.split(/\s+/).filter(Boolean)
  if (words.length === 1) return words[0].slice(0, oneWordLetters).toUpperCase()
  return words
    .slice(0, 2)
    .map(word => word[0].toUpperCase())
    .join('')
}

const SIZES = {
  sm: 'h-5 w-5 text-[10px]',
  md: 'h-6 w-6 text-[11px]',
  lg: 'h-8 w-8 text-xs',
} as const

export function AvatarInitials({
  name,
  size = 'md',
  className,
}: {
  name: string
  size?: keyof typeof SIZES
  className?: string
}) {
  return (
    <span
      aria-label={name}
      title={name}
      className={cn(
        'inline-flex items-center justify-center rounded-full bg-brand-50 text-foreground font-medium select-none',
        SIZES[size],
        className,
      )}
    >
      {initials(name) || '?'}
    </span>
  )
}
